import styled from "@emotion/styled"
import TextsText from "components/Texts/TextsText"

const TextThreeText = styled(TextsText)`
  font-size: 18px;
  line-height: 32px;
`

export default TextThreeText
